import { Bold } from '@tiptap/extension-bold';
import { BulletList } from '@tiptap/extension-bullet-list';
import { Document } from '@tiptap/extension-document';
import { Dropcursor } from '@tiptap/extension-dropcursor';
import { HardBreak } from '@tiptap/extension-hard-break';
import { History } from '@tiptap/extension-history';
import { Italic } from '@tiptap/extension-italic';
import { Link } from '@tiptap/extension-link';
import { ListItem } from '@tiptap/extension-list-item';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Strike } from '@tiptap/extension-strike';
import { Subscript } from '@tiptap/extension-subscript';
import { Superscript } from '@tiptap/extension-superscript';
import { Text } from '@tiptap/extension-text';
import { Underline } from '@tiptap/extension-underline';
export const extensions = [
    Document,
    Paragraph,
    Text,
    History,
    Dropcursor,
    HardBreak,
    Bold,
    Italic,
    Underline,
    Strike,
    Subscript,
    Superscript,
    BulletList,
    OrderedList,
    ListItem,
    Link.configure({ openOnClick: 'whenNotEditable' }),
];
export const editorProps = {
    attributes: {
        class: 'editor',
    },
};
